import { BaseGraphqlLayer } from '@core/base';
import { Injectable } from '@rxdi/core';
import { map } from 'rxjs/operators';

@Injectable()
export class UserService extends BaseGraphqlLayer {
  /** The signed-in user's record (role in `type`); always from the network. */
  me() {
    return this.query({ query: 'me.query.graphql', fetchPolicy: 'network-only' }).pipe(map((res) => res.data.me));
  }

  createUser(photoURL: string) {
    return this.mutate({
      mutation: 'create-user-mutation.graphql',
      variables: {
        payload: { photoURL },
      },
    }).pipe(map((res) => res.data.createFirebaseUser));
  }
}
